export default __webpack_public_path__ + "static/media/myPhoto.c601debe.jpg";